<script setup lang="ts">
import CustomAlert from "@/components/custom/CustomAlert.vue";
</script>

<template>
  <CustomAlert />
  <router-view />
</template>

<style lang="scss"></style>
